export const enum BuildingReviewLandingAutocompleteStatechartActionEnum {
  /**
   * Fetch autocomplete list items
   */
  fetchListItems = 'fetchListItems',

  /**
   * Show autocomplete loader
   */
  showLoader = 'showLoader',

  /**
   * Hide autocomplete loader
   */
  hideLoader = 'hideLoader',

  /**
   * Update list items in autocomplete
   */
  updateListItems = 'updateListItems',

  /**
   * Cancel current list items fetch
   */
  cancelCurrentFetch = 'cancelCurrentFetch',

  /**
   * Hide autocomplete list items dropdown
   */
  hideListItems = 'hideListItems',

  /**
   * Show autocomplete list items dropdown
   */
  showListItems = 'showListItems',

  /**
   * Reset selected location
   */
  resetSelection = 'resetSelection',

  /**
   * Update valuation form field
   */
  updateFormField = 'updateFormField',

  /**
   * Check if autocomplete has list items to show
   */
  checkIfHasListItems = 'checkIfHasListItems',
}
